import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from "vue";
import router from "@/router";
import HeyButton from "@/components/HeyButton.vue";
import NextIcon from "@/components/Icons/NextIcon.vue";
import sleep from "@/sleep";

// Variables

export default /*#__PURE__*/_defineComponent({
  __name: 'WelcomeView',
  setup(__props) {

// Imports
const heyInMultipleLanguages = ["hey", "ey", "hé", "おい", "嘿", "여기요"];
const currentText = ref("");

// Types text, then deletes it
async function typingEffect(text: string) {
  for (let i = 0; i < text.length; i++) {
    await sleep(250);

    const char = text[i];
    currentText.value += char;
  }

  await sleep(1000);

  for (let i = 0; i <= text.length; i++) {
    currentText.value = text.substring(0, text.length - i);

    await sleep(250);
  }
}
// When Welcome View is loaded, start doing typing animation
onMounted(async () => {
  let i = 0;

  while (i < heyInMultipleLanguages.length) {
    await typingEffect(heyInMultipleLanguages[i]);
    i += 1;

    // Start back at "Hey" (english)
    if (i == heyInMultipleLanguages.length) {
      i = 0;
    }
  }
});

// Update
localStorage.setItem("lastUpdated", "5/19/24");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", null, _toDisplayString(currentText.value), 1),
    _createVNode(HeyButton, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/auth')))
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Get Started "),
        _createVNode(NextIcon, { style: {"height":"1em"} })
      ]),
      _: 1
    })
  ], 64))
}
}

})